import { render, staticRenderFns } from "./DialogMessage.vue?vue&type=template&id=7e5e2b5e&scoped=true&"
import script from "./DialogMessage.vue?vue&type=script&lang=js&"
export * from "./DialogMessage.vue?vue&type=script&lang=js&"
import style0 from "./DialogMessage.vue?vue&type=style&index=0&id=7e5e2b5e&lang=scss&scoped=true&"
import style1 from "./DialogMessage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5e2b5e",
  null
  
)

export default component.exports